(angular => {
  "use strict";

  angular.module("Pages").controller("Pages.dashboardCtrl", [
    "$q",
    "$rootScope",
    "Loader",
    "Toast",
    "activityListFactory",
    "AuthService",
    "ParticipantService",
    "ActivityService",
    "$filter",
    DashboardCtrl
  ]);

  function DashboardCtrl($q, $rootScope, loader, toast, activityListFactory, authService, participantService, activityService, $filter) {
    this.user = authService.getTokenData();
    this.loaded = false;

    this.event = null;
    this.activities = [];
    this.availableTypes = [];
    this.acceptTerms = null;

    this.promise = loader.add(participantService.current()).then((participant) => {
      this.participant = participant;
      this.event = participant.event;

      this.banner = this.event.assets.filter(a => a.type === "banner").map(a => a.path)[0];
      this.footer = this.event.assets.filter(a => a.type === "footer").map(a => a.path)[0];
      if (!this.event.online) {
        this.term = this.event.assets.filter(a => a.type === "event_term").map(a => a.path)[0];
        this.privacy = this.event.assets.filter(a => a.type === "privacy_policy_term").map(a => a.path)[0];
      }

      this.confirmated = this.participant.status === "accepted";
      this.present = this.participant.status === "present";
      this.presentAtTime = this.participant.status === "present at time";
      this.notPresent = this.participant.status === "not present";

      if (!this.event.publish_appointment_book) {
        return [];
      }

      return loader.add(activityService.list());
    }).then(activities => {

      this.loaded = true;
      this.activities = activityListFactory(activities);
      this.availableTypes = this.getAvailableTypes(activities);
      this.readOnly = this.confirmated;

      if (this.confirmated) {
        return;
      }

      if (!this.event.spots_available) {
        this.readOnly = true;
        this.noSpotsAvailable = true;
        return;
      }
      const today = moment();
      const limit = moment(this.event.limit_date);

      if (today.isAfter(limit, 'day')) {
        this.readOnly = true;
        this.exceededDate = true;
        return;
      }

      if (this.event.activity_confirmation) {
        this.readOnly = !this.event.publish_appointment_book;
        return;
      }
    }).catch(err => toast.httpHandler(err));

    this.save = () => {
      if (this.readOnly) return;
      const activityIds = this.activities
        .reduce((acc, group) => acc.concat(group), [])
        .filter(a => a.subscribed && (a.spots - a.spots_used) > 0)
        .map(a => a.id);

      if (this.event.activity_confirmation) {
        if (!activityIds.length) {
          toast.show("Selecione ao menos uma atividade", "error");
          return;
        }

        if (this.event.minimum_activities > activityIds.length) {
          toast.show(`Selecione ao menos ${this.event.minimum_activities} atividades.`, "error");
          return;
        }
      }

      loader.add(participantService.confirm(activityIds)).then(() => {
        this.readOnly = true;
        this.confirmated = true;
        toast.show("Inscrição confirmada", "success");
        $rootScope.$emit('confirmPresence');
      }).catch(err => {
        toast.httpHandler(err);
      });
    };

    this.sendInvite = () => {
      const activityIds = this.activities
        .reduce((acc, group) => acc.concat(group), [])
        .filter(a => a.subscribed && (a.spots - a.spots_used) > 0)
        .map(a => a.id);

      if (this.event.activity_confirmation) {
        if (!activityIds.length) {
          toast.show("Selecione ao menos uma atividade", "error");
          return;
        }

        if (this.event.minimum_activities > activityIds.length) {
          toast.show(`Selecione ao menos ${this.event.minimum_activities} atividades.`, "error");
          return;
        }
      }

      loader.add(participantService.sendInvite(activityIds)).then((msg) => {
        if (msg) {
          toast.show(msg, "success");
        }
      }).catch(err => {
        toast.httpHandler(err);
      });
    };

    this.print = () => {
      window.print();
    };

    this.getAvailableTypes = (activities) => {
      const types = _.uniq(activities.map(a => a.type));
      return $filter('orderBy')(types);
    };

  }

})(angular);
